import React from "react";
import styles from "./CommanTable.module.scss";
import DataTable from "react-data-table-component";
import { combineClasses } from "utils/utils";
import Loader from "../loader/Loader";

const customStyles = {
  pagination: {
    style: {
      color: 'black',         // Change this to any color you like
      // fontWeight: 'bold',
      // fontSize: '14px',
    },
    pageButtonsStyle: {
      color: 'black',          // Buttons like page numbers
      '&:hover': {
        color: 'black',    // Hover color
      },
    },
  },
};


export const NewTable = ({
  columns,
  data = [],
  className = "",
  containerClassName = "",
  onRowClicked,
  progressPending = false,
  pagination = false,
  paginationServer = false,
  paginationTotalRows = 0,
  onChangeRowsPerPage = () => {},
  onChangePage = () => {},
  sortServer = false,
  onSort = () => {},
  defaultSortFieldId = "",
  expandableRows = false,
  expandableRowsComponent,
  expandableRowDisabled,
  paginationPerPage = 10,             // NEW
  paginationDefaultPage = 1          // NEW
}) => {
  return (
    <div className={combineClasses(styles.tableMainContainer, containerClassName || "")} style={{ height: "100%" }}>
      <DataTable
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        expandableRowDisabled={expandableRowDisabled}
        columns={columns}
        data={data}
        progressPending={progressPending}
        pagination={pagination}
        paginationServer={paginationServer}
        paginationTotalRows={paginationTotalRows}
        paginationPerPage={paginationPerPage}         // NEW
        paginationDefaultPage={paginationDefaultPage} // NEW
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        sortServer={sortServer}
        onSort={onSort}
        progressComponent={<Loader />}
        highlightOnHover
        responsive
        onRowClicked={onRowClicked}
        defaultSortFieldId={defaultSortFieldId}
        className={combineClasses(styles.table, className || "")}
        customStyles={customStyles}
      />
    </div>
  );
};
